import { useField } from 'formik';
import { Space } from 'antd';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';
import ShipmentIconOutlined from 'components/icons/ShipmentIconOutlined';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import FormInput from 'components/new-ui/composed/formInput/FormInput';
import { ManifestFormFields, ManifestFormSteps } from '../../types';

const fieldName = 'manifest.referenceId';

const Manifest = () => {
    const [field, meta, helpers] = useField(fieldName);
    const { isActive, isComplete, isIdle, resetStep, currentStepConfig } =
        useMultiStepFormContext<ManifestFormFields>();

    const disabled = currentStepConfig?.disabled ?? false;

    if (isIdle(ManifestFormSteps.MANIFEST)) {
        return <FormSectionHeader title="Manifest" icon={<ShipmentIconOutlined />} />;
    }

    if (isActive(ManifestFormSteps.MANIFEST)) {
        return (
            <Space style={{ width: '100%' }} direction="vertical" size={16}>
                <FormSectionHeader title="Manifest" icon={<ShipmentIconOutlined />} />
                <FormInput
                    required
                    placeholder="Enter manifest ID"
                    label="Manifest:"
                    disabled={disabled}
                    fieldProps={field}
                    fieldMeta={meta}
                    fieldHelper={helpers}
                />
            </Space>
        );
    }

    if (isComplete(ManifestFormSteps.MANIFEST)) {
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <FormSectionHeader title="Manifest" icon={<ShipmentIconOutlined />} />
                <ReadonlyFormItem
                    disabled={disabled}
                    onReset={() => resetStep(ManifestFormSteps.MANIFEST, 'referenceId')}
                    value={field.value}
                />
            </div>
        );
    }

    return null;
};

export default Manifest;
